import { render, staticRenderFns } from "./usersSvg.vue?vue&type=template&id=0dbd026d&"
import script from "./usersSvg.vue?vue&type=script&lang=js&"
export * from "./usersSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports